import getConfig from 'next/config';
import Document, { Head, Html, Main, NextScript } from 'next/document';
import Script from 'next/script';

const { publicRuntimeConfig } = getConfig();

const NO_PERSIST_TRACKING_PATHS = ['embed', 'page-embed'];

export const shouldDisableTrackingPersistance = (route) => {
  return NO_PERSIST_TRACKING_PATHS.includes(route?.split('/')[1]);
};

function GTM() {
  return {
    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-KHG3SC2');`
  };
}

function calendlyGTM() {
  return {
    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','calendlyDataLayer','GTM-K7NLBDC');`
  };
}

class MyDocument extends Document {
  static async getInitialProps(ctx) {
    const initialProps = await Document.getInitialProps(ctx);

    return { ...initialProps, route: ctx.pathname };
  }

  render() {
    // @ts-expect-error - TODO: Migrate this component to a function and have it properly typed.
    const { route } = this.props;
    const enableTrackers = publicRuntimeConfig.enableTrackers !== 'false' && !shouldDisableTrackingPersistance(route);

    return (
      <Html lang='en'>
        <Head />
        <body>
          <div id='scribe-portal' />
          <Main />
          <NextScript />
          <Script strategy='beforeInteractive' src='https://apis.google.com/js/api.js' />
          <Script strategy='beforeInteractive' src='https://accounts.google.com/gsi/client' />
          {/** Split this check into two lines because the scripts don't seem to render as expected when nested in a fragment */}
          {enableTrackers && <Script strategy='beforeInteractive' dangerouslySetInnerHTML={GTM()} type='text/javascript' />}
          {enableTrackers && <Script strategy='beforeInteractive' dangerouslySetInnerHTML={calendlyGTM()} type='text/javascript' />}
        </body>
      </Html>
    );
  }
}

export default MyDocument;
